import { FC, useState } from 'react';
import ReusableModal from '../common/Modal';
import { Box, Button, FormControl, FormLabel, TextField } from '@mui/material';
import { commonStyles } from '../../utils/styles/inputs';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { joinOrganizationApi } from '../../utils/apis';
import { useAlert } from '../../hooks/useAlert';
import MessagePopup from '../common/MessagePopup';

interface JoinOrganisationModalProps {
  open: boolean;
  onClose: () => void;
}

const JoinOrganisationModal: FC<JoinOrganisationModalProps> = ({
  open,
  onClose,
}) => {
  const queryClient = useQueryClient();
  const { alert, setAlert, showAlert } = useAlert();
  const [organizationCode, setOrganizationCode] = useState<string>('');
  const {
    mutateAsync: joinOrganisation,
    isPending: isJoinOrganisationPending,
  } = useMutation({
    mutationFn: joinOrganizationApi,
    onSuccess: () => {
      showAlert('Organization joined successfully', 'success');
      queryClient.invalidateQueries({ queryKey: ['get-organization'] });
      onClose();
    },
    onError: (error: any) => {
      showAlert(
        error?.response?.data?.message || 'Failed to join organization',
        'error'
      );
    },
  });

  const handleJoinOrganisation = async () => {
    await joinOrganisation({ organizationCode });
  };

  return (
    <>
      <ReusableModal open={open} onClose={onClose} title="Join Organization">
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FormControl fullWidth>
            <FormLabel sx={commonStyles.formLabel}>
              Enter Invitation Code
            </FormLabel>
            <TextField
              id="invitation-code"
              name="organizationCode"
              placeholder="Invitation Code"
              required
              fullWidth
              variant="outlined"
              sx={commonStyles.textField}
              value={organizationCode}
              onChange={e => setOrganizationCode(e.target.value)}
            />
          </FormControl>

          <Button
            variant="contained"
            sx={{ width: '100%', textTransform: 'none' }}
            disabled={!organizationCode || isJoinOrganisationPending}
            onClick={() => void handleJoinOrganisation()}
          >
            {isJoinOrganisationPending ? 'Joining...' : 'Join Organization'}
          </Button>
        </Box>
      </ReusableModal>
      <MessagePopup alert={alert} setAlert={setAlert} />
    </>
  );
};

export default JoinOrganisationModal;
